import { useSearchParams } from "react-router-dom";


const InputSearchOrders = ({ pullback }) => {

    const [searchParams] = useSearchParams()

    const defVal = searchParams.get('searchTerm')


    return (
        <>
            <div className='fh'>
                <div className='searchTypeRow mobOrange' >
                    <div className='searchType'>
                        <input type='search' placeholder='جستجوی سریع...' defaultValue={defVal} onChange={(e) => pullback(e.target.value)} />
                    </div>
                </div>
            </div>
        </>
    );
}

export default InputSearchOrders;